import { render } from "./RewardsListPage.vue?vue&type=template&id=1cc173a3&scoped=true"
import script from "./RewardsListPage.vue?vue&type=script&lang=js"
export * from "./RewardsListPage.vue?vue&type=script&lang=js"

import "./RewardsListPage.vue?vue&type=style&index=0&id=1cc173a3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc173a3"]])

export default __exports__